import { ref, type Ref } from 'vue';
import { Currency } from '@/modules/predefined/models/Currency';
import { Country } from '@/modules/predefined/models/Country';
import { Jurisdiction } from '@/modules/predefined/models/Jurisdiction';

export const currencies: Ref<Currency[] | undefined> = ref(undefined);
export const countries: Ref<Country[] | undefined> = ref(undefined);
export const activeCountries: Ref<Country[] | undefined> = ref(undefined);
export const jurisdictions: Ref<Jurisdiction[] | undefined> = ref(undefined);
